import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for admin scoped tooling
export const marketingToolingAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingAdminAccess],
  featureToggles: [FeatureToggle.marketingToolingEnabled], // rt_rfm_v2_enabled
  notFeatureToggles: [FeatureToggle.marketingToolingV2DisabledOverride], // rt_rfm_v2_disabled_overrides
}

// Permissive outer gate: lets any admin user enter the new campaigns route tree
// so per-page wrappers can decide whether to render or redirect to the legacy
// retailer-funded-marketing version. Page-level access control lives in the wrappers.
export const marketingToolingAdminCampaignBaseAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingAdminAccess],
}

// Matches the "user is on legacy version" check from
// retailerFundedMarketingAdminCustomCampaignAccessControl: NOT marketingToolingEnabled
// OR marketingToolingV2DisabledOverride.
export const marketingToolingAdminCampaignLegacyAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.MarketingToolingAdminAccess],
    notFeatureToggles: [FeatureToggle.marketingToolingEnabled],
  },
  {
    permissions: [Permission.MarketingToolingAdminAccess],
    featureToggles: [FeatureToggle.marketingToolingV2DisabledOverride],
  },
]
